import type { FC } from 'react';

import type { FilterValues } from '@iconik-io/shared-lib/src/redux/common_filters/types';

import type { OptionComponentProps } from '../../../select_field/types';
import { countSetMetadataFiltersForFields } from './count_set_metadata_filters_for_fields';

import styles from './metadata_view_option.module.css';

type MetadataViewOptionValue = {
  label?: string;
  value?: string;
  fields?: { name: string }[];
};

export const createMetadataViewOption = (
  filterValues: FilterValues,
): FC<OptionComponentProps> => {
  const MetadataViewOption: FC<
    OptionComponentProps<MetadataViewOptionValue>
  > = ({ option = {} }) => {
    const { label, fields } = option;
    const count = countSetMetadataFiltersForFields(fields, filterValues);

    return (
      <span className={styles.option}>
        <span className={styles.label}>{label}</span>
        {count > 0 ? <span className={styles.filter_dot} /> : null}
      </span>
    );
  };

  return MetadataViewOption;
};
